import { GetCatalogsType } from "../../../fnx/catalog/getCatalogsType";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getCatalogsTypeClearData } from "../../../store/catalog/actions";
export var UserCatalogData = function () {
    var dispatch = useDispatch();
    var _a = React.useState([]), genderList = _a[0], setGenderList = _a[1];
    var _b = GetCatalogsType(true, true, 1, 10, "CATALOG_SEXO"), responseGetCatalogsType = _b.responseGetCatalogsType, loadingGetCatalogsType = _b.loadingGetCatalogsType, errorGetCatalogsType = _b.errorGetCatalogsType;
    useEffect(function () {
        if ((responseGetCatalogsType === null || responseGetCatalogsType === void 0 ? void 0 : responseGetCatalogsType.length) > 0) {
            var newList = responseGetCatalogsType.map(function (item) { return ({
                id: item.id,
                name: item.description,
                value: item.id,
            }); });
            setGenderList(newList);
            dispatch(getCatalogsTypeClearData());
        }
    }, [responseGetCatalogsType]);
    return { genderList: genderList, errorGetCatalogsType: errorGetCatalogsType, loadingGetCatalogsType: loadingGetCatalogsType };
};
